import axios from "axios";
var AxiosClientFactory = /** @class */ (function () {
    function AxiosClientFactory(name, axiosConfig) {
        this.name = name;
        this.axiosConfig = axiosConfig;
        this.transformInstanceFunctions = [];
    }
    AxiosClientFactory.prototype.addInstanceTransform = function (transformation) {
        this.transformInstanceFunctions.push(transformation);
    };
    AxiosClientFactory.prototype.createInstance = function () {
        var instance = axios.create(this.axiosConfig);
        this.transformInstanceFunctions.forEach(function (fn) { return fn === null || fn === void 0 ? void 0 : fn(instance); });
        return instance;
    };
    return AxiosClientFactory;
}());
export { AxiosClientFactory };
